import React, {  } from 'react';
import { useSelector } from 'react-redux';
import { getOrganizatorFromRoles } from '../../../common/Tool';
import SeriiBlock from '../../components/SeriiBlock'
import PageLayout from '../../components/PageLayout';
import { GET, errorCatch, useAuth } from 'fennec-ui';
import { useOrganizerContext } from '../../../common/Context';

export default function OrganizerEventsSerii(props) {
    const [org, setOrg] = useOrganizerContext();
    // const organizator = useSelector(getOrganizatorFromRoles(["ОрганизаторФедерации", "АдминистраторОрганизатораФедерации"], true)); // Организатор
    // const auth = useAuth()
    // const [organizator, setOrganizator] = React.useState([])
    // React.useEffect(()=>{
    //     GET(auth, '/api/org/list-by-admin', ({data})=>{
    //         setOrganizator(data);
    //     }, errorCatch)
    // }, [])

    // const context = React.useMemo(() => ({
    //     collection: organizator,
    //     title: "Организатор",
    //     name: (item) => item.nazvanie,
    //     mix: (item) => {
    //         return {
    //             // organizatorFederatsiyaID: 1, // Организатор федерация
    //             // organizatorShkolaID: item.ID, // Организатор школа
    //             organizatorMeropriyatiyaID: item?.ID, // Организатор мероприятия
    //             // organizatorRegionalnoeOtdelenieID: item.ID // Организатор региональное отделение
    //         }
    //     }
    // }), [organizator])

    return (<PageLayout>
        {org && <SeriiBlock auth={props.auth} source={"/api/serii/list/org"}
            base="organizer"
            sourceKey="org"
            create={true}
            // context={context}
            ctx={{ organizatorMeropriyatiyaID: org?.ID }}
        />}
        </PageLayout>
    );
}
